import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';

import { SeoBlock } from '../../../../components/SeoBlock';
import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { generateSeoTitle } from '../../../../utils/helpers';

interface SearchSeoBlockProps {
  tenantTitle?: string | null;
  tenantName?: string | null;
}

const SEARCH_PAGE_SEO_IMAGE = 'headers-images/5.png';
const GLOSSARY_SEO_IMAGE_FU = '/page-images/glossarySeoImg.png';
const GLOSSARY_SEO_IMAGE_SU = '/page-images/glossarySeoImgSU.png';
const GLOSSARY_SEO_IMAGE_ELOD = '/page-images/glossarySeoImgELOD.png';

const getGlossarySeoImg = (tenantName) => {
  switch (tenantName) {
    case 'sustainabilityunlocked':
      return GLOSSARY_SEO_IMAGE_SU;
    case 'euromoney':
      return GLOSSARY_SEO_IMAGE_ELOD;
    case 'financeunlocked':
      return GLOSSARY_SEO_IMAGE_FU;
    default:
      return GLOSSARY_SEO_IMAGE_FU;
  }
};

const SearchSeoBlock: FC<SearchSeoBlockProps> = ({ tenantTitle, tenantName }) => {
  const { t } = useTranslation();

  const glossarySeoImg = getGlossarySeoImg(tenantName);

  return (
    <Switch>
      <Route
        path={`${DEFAULT_DISCOVER_URL}/search`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(
                t(`page.discover.title.${tenantName}`) || t('page.discover.title.default'),
                tenantTitle,
              ),
              share_image: SEARCH_PAGE_SEO_IMAGE,
            }}
            canonicalUrl={`${DEFAULT_DISCOVER_URL}/search`}
          />
        )}
      />
      <Route
        path={[`${DEFAULT_DISCOVER_URL}/videos`, '/videos']}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.browseVideoModules'), tenantTitle),
              seo_description: t('page.discover.videosDescription'),
            }}
            canonicalUrl={`${DEFAULT_DISCOVER_URL}/videos`}
          />
        )}
      />
      <Route
        path={[`${DEFAULT_DISCOVER_URL}/pathways`, '/pathways']}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.browsePathways'), tenantTitle),
              seo_description: t('page.discover.pathwaysDescription'),
            }}
            canonicalUrl={`${DEFAULT_DISCOVER_URL}/pathways`}
          />
        )}
      />
      <Route
        path={`${DEFAULT_DISCOVER_URL}/insights`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.browseInsights'), tenantTitle),
              seo_description: t('page.discover.textDescription'),
            }}
            canonicalUrl={`${DEFAULT_DISCOVER_URL}/insights`}
          />
        )}
      />
      <Route
        path={`${DEFAULT_DISCOVER_URL}/glossary`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.browseGlossary'), tenantTitle),
              seo_description: t('page.discover.glossaryDescription'),
              share_image: glossarySeoImg,
            }}
            canonicalUrl={`${DEFAULT_DISCOVER_URL}/glossary`}
          />
        )}
      />
    </Switch>
  );
};

export default SearchSeoBlock;
